import { ROUTES } from '@/constants';

export const sidebarItems = [
	{ label: 'Legalización y apostillas', to: ROUTES.SERVICIOS_LEGALIZACION_APOSTILLAS },
	{ label: 'Copias de Archivos de Protocolo', to: ROUTES.SERVICIOS_COPIAS_ARCHIVOS_PROTOCOLO },
	{ label: 'Atención al ciudadano', to: ROUTES.SERVICIOS_ATENCION_CIUDADANO },
	{ label: 'Expedientes Matrimoniales', to: ROUTES.SERVICIOS_EXPEDIENTES_MATRIMONIALES },
	{ label: 'Portal de Empleo', to: ROUTES.SERVICIOS_PORTAL_EMPLEO },
];
